function matchArray<T>(arr1: readonly T[], arr2: readonly T[]): boolean {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
        return false;
    }

    if (arr1.length !== arr2.length) {
        return false;
    }

    return arr1.every((item, index): any => item === arr2[index]);
}

// ----------------------------------------------------------------------------

export default matchArray;
